import AltNavbar from '../components/AltNavbar'
import {Container} from '@mui/material'
import "../css/userprofile.css"
import {useAppContext} from "../context/appContext";

const UserProfile = () => {
    const {state} = useAppContext();
    const {customer} = state;
    return (
        <div>
            <AltNavbar/>
            <Container>
                <div className='infoContainer'>
                    <div className="infoRow">
                        <div>
                            <p>
                                <strong>
                                    Email:
                                </strong>
                            </p>
                        </div>
                        <div>
                            <p>
                                {customer.email}
                            </p>
                        </div>
                    </div>
                    <div className="infoRow">
                        <div>
                            <p>
                                <strong>
                                    First Name
                                </strong>
                            </p>
                        </div>
                        <div>
                            <p>
                                {customer.first_name}
                            </p>
                        </div>
                    </div>
                    <div className="infoRow">
                        <div>
                            <p>
                                <strong>
                                    Account Type:
                                </strong>
                            </p>
                        </div>
                        <div>
                            <p>
                                {customer.customer_type}
                            </p>
                        </div>
                    </div>
                </div>
            </Container>
        </div>
    )
}

export default UserProfile